import ResizeObserver from 'resize-observer-polyfill';
import $ from 'jquery';

export default class DeliveryPackages {
	constructor(el) {
		this.DOM = { el: el };
		this.DOM.tabs = Array.from(el.querySelectorAll('[data-delivery-package]'));

		this.initEvents();
	}

    setAttributeHeights() {
        const attributes = document.querySelectorAll("[data-attribute]");
        if (attributes) {
            const attributeHeights = {}
            attributes.forEach((attribute) => {
                const attributeKey = attribute.dataset.attribute;
                attributeHeights[attributeKey] = Math.max(attribute.offsetHeight, attributeHeights?.[attributeKey] || 0);
            });

            attributes.forEach((attribute) => {
                attribute.style.height = `${(attributeHeights[attribute.dataset.attribute])}px`;
            });
        }
    }

	initEvents() {
		const resizeObserver = new ResizeObserver((entries) => {
			let top = 0;

			for (const entry of entries) {
				top = Math.max(top, entry.target.offsetHeight);
			}

            this.setAttributeHeights();

			this.DOM.el.style.top = `-${top + 1}px`;
		});

		this.DOM.tabs.forEach((tab) => {
			resizeObserver.observe(tab);
		});
	}
}

const deliveryPackages = Array.from(document.querySelectorAll('[data-delivery-packages]'));
if (deliveryPackages !== null) {
	deliveryPackages.forEach((el) => {
		new DeliveryPackages(el);
	});
}

$('#vehicle-delivery-packages,#vehicle-delivery-packages-intro').each(function () {
	$(this).on('shown.bs.modal', function () {
		/* Dispatch resize event for delivery packages */
		window.dispatchEvent(new Event('resize'));
	});
});
